import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, User, Briefcase, Building2, Sparkles, Leaf, Cpu, Rocket } from "lucide-react";
import { Button } from "./ui/button";

const CARDS = [
  {
    id: "privato",
    icon: User,
    titolo: "Privato",
    text: "Trasforma le tue competenze in un reddito extra: creator, tutor, micro-servizi digitali.",
  },
  {
    id: "professionista",
    icon: Briefcase,
    titolo: "Professionista",
    text: "Amplia la tua offerta con AI, blockchain, ESG e ottieni visibilità sul Registro Nazionale.",
  },
  {
    id: "azienda",
    icon: Building2,
    titolo: "Azienda",
    text: "Trasformazione digitale e sostenibile, incentivi 4.0/5.0 e formazione on-site del team.",
  },
];

export default function OpportunitaHome() {
  return (
    <section
      id="opportunita-extra"
      data-testid="home-opportunita-extra"
      className="relative py-20 md:py-24 bg-gradient-to-b from-white via-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f59e0b]/10 border border-[#f59e0b]/30">
              <Sparkles className="h-3.5 w-3.5 text-[#f59e0b]" />
              <span className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#f59e0b]">
                Novità · Opportunità Extra
              </span>
            </div>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
              Un <span className="text-[#f59e0b]">reddito extra</span> grazie al digitale, alla tecnologia e alla sostenibilità.
            </h2>
            <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">
              Grazie ad ACDT e alla nostra rete di <strong>aziende partner</strong>, attivi
              percorsi dedicati che ti permettono di generare valore reale. Che tu sia un
              privato, un professionista o un'azienda, c'è un percorso per te.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3 text-sm font-semibold text-slate-700">
              <span className="inline-flex items-center gap-1.5">
                <Cpu className="h-4 w-4 text-[#0a1f55]" /> Digitale
              </span>
              <span className="text-slate-300">•</span>
              <span className="inline-flex items-center gap-1.5">
                <Rocket className="h-4 w-4 text-[#0a1f55]" /> Tecnologia
              </span>
              <span className="text-slate-300">•</span>
              <span className="inline-flex items-center gap-1.5">
                <Leaf className="h-4 w-4 text-[#0a1f55]" /> Sostenibilità
              </span>
            </div>
            <div className="mt-7">
              <Link to="/opportunita-extra">
                <Button
                  data-testid="home-cta-opportunita"
                  className="bg-[#0a1f55] hover:bg-[#102a6b] text-white font-bold h-12 px-6"
                >
                  Scopri tutte le opportunità
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-3 gap-4">
              {CARDS.map((c) => {
                const I = c.icon;
                return (
                  <Link
                    key={c.id}
                    to={`/opportunita-extra#${c.id}`}
                    data-testid={`home-opportunita-card-${c.id}`}
                    className="group p-6 rounded-2xl bg-white border border-slate-200 hover:border-[#f59e0b]/50 hover:shadow-xl transition-all"
                  >
                    <div className="h-12 w-12 rounded-xl bg-[#0a1f55] text-[#fbbf24] flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <I className="h-5 w-5" />
                    </div>
                    <div className="text-lg font-extrabold text-[#0a1f55]">{c.titolo}</div>
                    <div className="mt-1.5 text-sm text-slate-600 leading-relaxed">{c.text}</div>
                    <div className="mt-4 inline-flex items-center gap-1 text-[13px] font-bold text-[#f59e0b]">
                      Vai al percorso <ArrowRight className="h-3.5 w-3.5" />
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
